import { urls } from "../../../../config";
import Flask from "../Flask";

export const setMonth = ()=>{
    const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const d = new Date();
    let nmonth = month.slice(d.getMonth()+1).concat(month.slice(0,d.getMonth()+1))
    return nmonth
}

export const moveChart = (direction) => {
    const graphLoc = document.getElementById('div-graph01')
    let margs = graphLoc.style.marginLeft;
    if (margs === "-48%" && direction == 'left')
      graphLoc.style.marginLeft = ''

    if (margs === "" && direction == 'right')
      graphLoc.style.marginLeft = '-48%'
}

export const getServerCount = async (stateFunction,filterData,urloptions) =>{
    const controller = new AbortController();
    const paramStr = new URLSearchParams(filterData).toString();
    const signal = controller.signal;
    await Flask.get('/api-cam/servers/?'+paramStr,urloptions)
    .then(resp=>{
        stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
    }).catch(err=>{
    console.log(err);
    });
}

export const getOrderCount = async (stateFunction,filterData,urloptions) =>{
  const paramStr = new URLSearchParams(filterData).toString();
    await Flask.get('/api-cam/orders/?'+paramStr,urloptions)
    .then(resp=>{
        stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
    }).catch(err=>{
    console.log(err);
    });
}
export const getAssetCount = async (stateFunction,filterData,urloptions) =>{
  const paramStr = new URLSearchParams(filterData).toString();
  await Flask.get('/api-cam/orders/asset/?'+paramStr,urloptions)
  .then(resp=>{
    stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
  }).catch(err=>{
    console.log(err)
  })
}

export const getOrderGraph = async (stateFunction,filterData,urloptions) =>{
  const paramStr = new URLSearchParams(filterData).toString();
  await Flask.get('/api-cam/orders/graph/?'+paramStr,urloptions)
  .then(resp=>{
    var total = JSON.parse(`${resp.data.replaceAll("'",'"')}`);
    
    total[2] = sumOrder(total[0],total[1]);
    stateFunction(total);
  }).catch(err=>{
    console.log(err)
  })
}

export const getServerGraph = async (stateFunction,filterData,urloptions) =>{
    const paramStr = new URLSearchParams(filterData).toString();
    await Flask.get('/api-cam/servers/graph/?'+paramStr,urloptions)
    .then(resp=>{
       stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
    }).catch(err=>{
        console.log(err)
    });
}

const sumOrder = (arr1,arr2) => {
  let total = []
  for(var i=0, len=arr1.length;  i<len; i++){
    total[i] = parseInt(arr1[i]) + parseInt(arr2[i]);  
  }
  return total;
}


export const getServerType = async (stateFunction,filterData,urloptions) =>{
  const paramStr = new URLSearchParams(filterData).toString();
  await Flask.get('/api-cam/servers/type/?'+paramStr,urloptions)
  .then(resp=>{
    stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
  }).catch(err=>{
    console.log(err)
  })
}

export const getServerRegion = async (stateFunction,filterData,urloptions) =>{
  const paramStr = new URLSearchParams(filterData).toString();
  await Flask.get('/api-cam/servers/region/?'+paramStr,urloptions)
  .then(resp=>{
    stateFunction(JSON.parse(`${resp.data.replaceAll("'",'"')}`))
  }).catch(err=>{
    console.log(err)
  })
}

export const getServerData = (data) => {
  return {
    labels: [
      'Internal',
      'External'
    ],
    datasets: [{
      label: 'Server List',
      data: data,
      backgroundColor: [
        '#66039f',
        '#F7D000',
        '#333333'
      ],
      hoverOffset: 4
    }]
  }
};

export const getApproval = async (stateFunction,filterData,urloptions) => {
  const idToken = localStorage.getItem("token");
  // const customerEnterpriseId = email.split("@")[0];
  const customerEnterpriseId = 'naveen.kalasamudram'
  //if (customerEnterpriseId && idToken) {
  await Flask.get(`/provision/mywizard-aiops/read/all?userepid=${customerEnterpriseId}`,urloptions) 
  .then((res) => {
    console.log(res.data);
  })
  .catch((err) => {
    console.log("Async error", err);
  });
  //}
};